import React from "react";

import Header from "../components/Header";
import Footer from "../components/Footer";

import Alerts from "../components/Alert";
import Notification from "../components/Notification";
import NewsFlash from "../components/NewsFlash";
import Phases from "../components/Phase";
import { useGlobalState } from "../context/Global";

const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

function Dashboard() {
  const { data, openNewsFlash } = useGlobalState();

  return (
    <>
      <Header />
      <Alerts />
      <NewsFlash />

      <div className="xl:container px-8" style={isIE11 ? { maxWidth: "1280px" } : {}}>
        <div className="flex -mx-6 mb-4">
          <aside className="w-1/3 px-6 content">
            <p>
              Click <a onClick={() => openNewsFlash()} href="#">here</a> to see the latest newsflash again.
            </p>
            <div dangerouslySetInnerHTML={{ __html: data?.intro }} />
          </aside>
          <main className="w-2/3 px-6 ">
            <Notification id="info" type="info" />
            <Phases type="large" />
          </main>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default Dashboard;
